import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {TransporterPriceState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class TransporterPriceQuery extends QueryEntity<TransporterPriceState> {

  constructor(protected store: Store) {
    super(store);
  }

}
